import { render } from "./EmailRegistration.vue?vue&type=template&id=6b9c43cd&scoped=true&ts=true"
import script from "./EmailRegistration.ts?vue&type=script&lang=ts&external"
export * from "./EmailRegistration.ts?vue&type=script&lang=ts&external"

import "./EmailRegistration.scss?vue&type=style&index=0&id=6b9c43cd&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9c43cd"]])

export default __exports__